<template>
    <div class="products-distribution-table-form flex-grow-1">
        <div class="position-relative h-100 pb-5">
            <div v-if="packages.length > 0" class="btn-reset-wrap">
                <b-btn variant="danger"
                       class="mt-3 mb-3 ml-auto"
                       size="sm"
                       @click="resetPackages">
                    Reset packages
                </b-btn>
            </div>
            <div class="scroll-x" :class="{'pt-reset': packages.length > 0}">
                <transition name="fade" mode="out-in">
                    <b-alert class="shadow" :show="showError" variant="danger" v-if="showError" dismissible>
                        <ol class="mb-0">
                            <li v-for="(error, index) in getErrorMessage" :key="index">{{error}}</li>
                        </ol>
                    </b-alert>
                </transition>
                <b-table
                    v-if="products.length > 0"
                    id="packages-table"
                    show-empty
                    :class="['table-bordered']"
                    :busy="$store.state.loading"
                    :items="products"
                    :fields="[...fields, ...actionColumn]"
                    foot-clone
                    :tbody-tr-class="tableClass">

                    <div slot="table-busy" class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>

                    <b-btn slot="HEAD_addPackage"
                           slot-scope="data"
                           variant="primary-user"
                           class="font-weight-bold text-nowrap"
                           v-if="packages.length < 10"
                           @click="addPackage">
                        Add package
                    </b-btn>
<!--                    <template slot="addPackage"-->
<!--                              slot-scope="data"-->
<!--                              class="bg-primary"-->
<!--                              v-if="packages.length < 10">-->
<!--                        test-->
<!--                    </template>-->

                    <template v-for="(field, index) in fields"
                              :slot="'HEAD_'+ field.key"
                              slot-scope="data">
                        <div :key="field.key" v-if="field.key === `package${index - 1}`">
                            {{field.label}}
                            <b-btn v-if="fields.length === index + 1"
                                   variant="link"
                                   class="text-danger text-decoration-none remove-package-btn"
                                   @click="removePackage(index)">×
                            </b-btn>
                        </div>
                        <span :key="field.key" v-else>{{field.label}}</span>
                    </template>
                    <template v-for="(field, index) in fields"
                              :slot="field.key"
                              slot-scope="data">
                        <div :key="field.key" v-if="field.key.includes('package')">
                            <b-form-input type="text"
                                          :name="`${field.key}-quantity-${data.item.id}`"
                                          v-validate="'numeric|min_value:0'"
                                          autocomplete="off"
                                          :class="{'is-invalid': errors.has(`${field.key}-quantity-${data.item.id}`) }"
                                          @input.native="setPackageQ($event, packages[index - 2].parcelInventory,  data.item.id)"/>
                        </div>
                    </template>
                    <div slot="itemInfo" slot-scope="data" class="font-weight-bold">
                        {{data.item.product.name}}
                        <!-- <pre>
                            {{data.item}}
                        </pre> -->
                        <span>SKU: {{data.item.product.sku}}</span>
                        <span>FNSKU: {{data.item.product.fnsku}}</span>
                    </div>
                    <template v-for="(field, index) in fields"
                              :slot="'FOOT_'+ field.key"
                              slot-scope="data">
                        <div :key="field.key" v-if="field.key === `package${index - 1}`" class="h-100">
                            <div class="input-group-size" :class="{'table-danger': errorSizePackage[index - 2].weight}">
                                <b-form-input type="text"
                                              v-model="values[`${field.key}-weight`]"
                                              :name="`${field.key}-weight`"
                                              v-validate="`min:1|max_value:${weightLimitation}`"
                                              :class="{'is-invalid': errors.has(`${field.key}-weight`)}"
                                              class="form-control-weight"
                                              @change="setSizes($event, packages[index - 2], 'weight')"
                                              @input="resetSizeInputError(index - 2)"/>
                            </div>
                            <div class="input-group-size"
                                 :class="{'table-danger': errorSizePackage[index - 2].dimensions}">
                                <b-form-input type="text"
                                              v-model="values[`${field.key}-length`]"
                                              :name="`${field.key}-length`"
                                              v-validate="'numeric|min:1'"
                                              :class="{'is-invalid': errors.has(`${field.key}-length`)}"
                                              class="input-group-size__length"
                                              @change="setSizes($event, packages[index - 2], 'length')"
                                              @input="resetSizeInputError(index - 2)"/>
                                <span>x</span>
                                <b-form-input type="text"
                                              v-model="values[`${field.key}-width`]"
                                              :name="`${field.key}-width`"
                                              v-validate="'numeric|min:1'"
                                              :class="{'is-invalid': errors.has(`${field.key}-width`)}"
                                              class="input-group-size__width"
                                              @change="setSizes($event, packages[index - 2], 'width')"
                                              @input="resetSizeInputError(index - 2)"/>
                                <span>x</span>
                                <b-form-input type="text"
                                              v-model="values[`${field.key}-height`]"
                                              :name="`${field.key}-height`"
                                              v-validate="'numeric|min:1'"
                                              :class="{'is-invalid': errors.has(`${field.key}-height`)}"
                                              class="input-group-size__height"
                                              @change="setSizes($event, packages[index - 2], 'height')"
                                              @input="resetSizeInputError(index - 2)"/>
                            </div>
                        </div>
                    </template>
                    <template slot="quantitySent"
                              slot-scope="data">
                        <b>{{data.value}}</b>
                    </template>
                    <div slot="FOOT_quantitySent"
                         slot-scope="data"
                         class="quantity-sent">
                        <span>Weight:</span>
                        <span>Dimensions:</span>
                    </div>
                    <template slot="FOOT_addPackage" slot-scope="data"></template>
                </b-table>
            </div>
            <div class="table-user-footer">
                <b class="d-block">Limitations for one box - up to {{weightLimitation}}kg max.</b>
                <div class="d-flex justify-content-between align-items-end">
                    <div class="pt-3">
                        <b class="d-block pb-3">Are packages packed on a pallet?</b>
                        <b-btn :variant="packageType === 'c_palete' ? 'primary-user' : 'outline-user-primary'"
                               size="sm"
                               :disabled="packages.length === 0"
                               @click="packageType = 'c_palete'">
                            Yes
                        </b-btn>
                        <b-btn :variant="packageType === 'c_deze' ? 'primary-user' : 'outline-user-primary'"
                               size="sm"
                               :disabled="packages.length === 0"
                               @click="packageType = 'c_deze'">
                            No
                        </b-btn>
                    </div>
                    <b-btn variant="primary-user"
                           class="mt-4"
                           size="sm"
                           :disabled="packages.length === 0 || showError"
                           @click="validateData">
                        Continue
                    </b-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: 'Step2',
        data() {
            return {
                products: [],
                fields: [
                    {
                        key: 'itemInfo',
                        label: ''
                    },
                    {
                        key: 'quantitySent',
                        label: 'Shipping units'
                    }
                ],
                actionColumn: [{
                    key: 'addPackage',
                    label: '',
                    thStyle: {width: '50px', minWidth: '50px'}
                }],
                packages: [],
                packageType: 'c_deze',
                values: {},
                errorMessages: {},
                errorSizePackage: {},
                weightLimitation: 30
            }
        },
        created() {
            this.getPlanProducts()
        },
        computed: {
            getErrorMessage() {
                return this.errorMessages
            },
            showError() {
                return Object.keys(this.errorMessages).length > 0
            }
        },
        methods: {
            resetSizeInputError(index) {
                this.errorSizePackage[index].weight = false
                this.errorSizePackage[index].dimensions = false
                delete this.errorMessages.dimensions
                Vue.set(this.$data, 'errorMessages', Object.assign({}, this.errorMessages))
            },
            packageIsNotEmpty(index) {
                let sum = this.packages[index].parcelInventory.reduce((previousValue, currentValue, index, array) => {
                    return previousValue + parseInt(currentValue.quantity === '' ? 0 : currentValue.quantity)
                }, 0)

                let testSetSize = Number(this.packages[index].height) !== 0 &&
                    Number(this.packages[index].length) !== 0 &&
                    Number(this.packages[index].weight) !== 0 &&
                    Number(this.packages[index].width) !== 0

                if (sum > 0 && !testSetSize) {
                    this.errorSizePackage[index].weight = true
                    this.errorSizePackage[index].dimensions = true
                    this.errorMessages.dimensions = 'Weigth and dimensions fields is required'
                } else {
                    this.errorSizePackage[index].weight = false
                    this.errorSizePackage[index].dimensions = false
                }
            },
            packageSizeValidation() {
                this.packages.forEach((item, index) => {
                    this.packageIsNotEmpty(index)
                })
            },
            productQuantityValidation(id) {
                let product = []
                let productQuantitySent = this.products.filter(product => product.id === id)
                let sum = 0
                let error = false
                let errorMessage = ''

                this.packages.forEach(pack => {
                    product.push(...pack.parcelInventory.filter(product => product.inventoryId === id))
                })

                if (product.length > 0) {
                    sum = product.reduce((previousValue, currentValue, index, array) => {
                        return previousValue + parseInt(currentValue.quantity === '' ? 0 : currentValue.quantity)
                    }, 0)
                }

                switch (true) {
                    case sum < productQuantitySent[0].quantitySent:
                        error = true
                        errorMessage = `You must have ${productQuantitySent[0].quantitySent - sum} more ${productQuantitySent[0].product.name}.`
                        break
                    case productQuantitySent[0].quantitySent < sum:
                        error = true
                        errorMessage = `Not enough ${productQuantitySent[0].product.name}.`
                        break
                    default:
                        error = false
                }

                if (error) {
                    productQuantitySent[0].status = 'danger'
                    this.errorMessages[id] = errorMessage
                } else {
                    productQuantitySent[0].status = ''
                    delete this.errorMessages[id]
                }
                Vue.set(this.$data, 'errorMessages', Object.assign({}, this.errorMessages))
            },
            allProductValidation() {
                this.products.forEach(product => {
                    this.productQuantityValidation(product.id)
                })
            },
            tableClass(item) {
                if (item !== null && item.status === 'danger') {
                    return 'table-danger'
                }
                return ''
            },
            getPlanProducts() {
                this.$api('GET', this.$endpoints.incomesItems(this.$route.params.planId)).then(response => {
                    this.products = response
                    this.products.forEach(item => {
                        item.status = ''
                    })
                })
            },
            addPackage() {
                let number = this.fields.length - 1
                this.fields.push({
                    key: `package${number}`,
                    label: `${number} package`
                })
                this.packages[number - 1] = {
                    weight: 0,
                    length: 0,
                    width: 0,
                    height: 0,
                    parcelInventory: this.products.map(item => {
                        return {
                            inventoryId: item.id,
                            quantity: 0
                        }
                    })
                }
                this.errorSizePackage[number - 1] = {
                    weight: false,
                    dimensions: false
                }
            },
            removePackage(index) {
                this.fields.splice(index, 1)
                this.packages.splice(index - 2, 1)
                this.products.forEach(item => {
                    this.productQuantityValidation(item.id)
                })
            },
            resetPackages() {
                let tmp = this.products
                Object.assign(this.$data, this.$options.data())
                this.products = tmp
                this.addPackage()
            },
            setPackageQ(e, packageItem, id) {
                packageItem.find(item => item.inventoryId === id).quantity = e.target.value
                this.productQuantityValidation(id)
            },
            setSizes(value, packageItem, key) {
                packageItem[key] = value
            },
            validateData() {
                this.allProductValidation()
                this.packageSizeValidation()
                this.$validator.validateAll().then((result) => {
                    if (result && !this.showError) {
                        this.nextStep()
                    } else {
                        console.log('error')
                    }
                })
            },
            nextStep() {
                return this.$helper.multipleRequests({
                    method: 'POST',
                    url: this.$endpoints.incomesParcels(this.$route.params.planId),
                    arr: this.packages.map(packageItem => {
                        return {
                            ...packageItem,
                            packageType: this.packageType
                        }
                    })
                }).then(() => this.$router.push({name: 'Step3'}))
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/style/utils/_variables.scss";

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .5s ease-out;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
    .products-distribution-table-form {
        .alert {
            position: fixed;
            top: 30px;
            left: 15px;
            max-width: 520px;
            z-index: 9;
            ol {
                padding-left: 7px;
            }
        }
        .btn-reset-wrap {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 1;
        }
        .btn-continue-wrap {
            position: absolute;
            left: 0;
            bottom: 30px;
            .btn-outline-user-primary {
                color: $text-default-color-user;
            }
        }
        .pt-reset {
            padding-top: 80px;
        }
        b {
            font-size: 14px;
            display: block;
        }
        .table {
            .btn-full {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                &:focus,
                &:not(:disabled):not(.disabled):active:focus,
                &:not(:disabled):not(.disabled).active:focus {
                    box-shadow: none;
                }
            }
            thead {
                th {
                    position: relative;
                    padding: 0 5px 0 5px;
                    text-align: center;
                    vertical-align: middle;
                    height: 40px;
                }
            }
            thead,
            tbody {
                tr {
                    td {
                        vertical-align: middle;
                        &:first-child {
                            width: 190px;
                            min-width: 190px;
                        }
                        &:last-child {
                            width: 50px;
                            min-width: 50px;
                        }
                        &:not(:first-child):not(:last-child) {
                            min-width: 8vw;
                            position: relative;
                            text-align: center;
                            input {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                // right: 0;
                                transform: translate(-50%, -50%)
                                // bottom: 0;
                            }
                        }
                    }
                }
            }
            tfoot {
                th,
                td {
                    padding: 0;
                }
                .quantity-sent {
                    span {
                        display: flex;
                        height: 60px;
                        padding: 10px;
                        align-items: center;
                        justify-content: center;
                        font-weight: bold;
                        & + span {
                            border-top: 1px solid $gray-300;
                        }
                    }
                }
                // .form-control-weight,
                .input-group-size {
                    height: 60px;
                }
                .input-group-size {
                    display: flex;
                    align-items: center;
                    justify-content: space-around;
                    border-top: 1px solid $gray-300;
                    // width: 80%;
                    padding-left: 10%;
                    padding-right: 10%;
                    span {
                        padding: 0 5px;
                    }
                    input {
                        // height: 100%;
                        // flex: 0025%;
                        // max-width: 25%;
                        // &.form-control-weight {
                        //     flex: 0080%;
                        //     max-width: 80%;
                        // }

                    }
                    &__length {
                        text-align: right;
                    }
                    &__height {
                        text-align: left;
                    }
                }
            }
            input {
                font-size: 14px;
                // height: 100%;
                text-align: center;
                padding-left: 3px;
                padding-right: 3px;
                // background-color: transparent;
                // border: none;
                border-radius: 0;
                font-weight: bold;
                cursor: pointer;
                &:focus {
                    border-color: $text-default-color-user;
                    box-shadow: 0 0 0 0.2rem rgba($text-default-color-user, 0.25);
                }
                &.is-invalid {
                    border: 2px solid #dc3545;
                    padding-right: 0.75rem;
                    background-image: none;
                }
                &:not([class^='input-group-size__']):not(.form-control-weight) {
                    width: 80%;
                }
            }
        }
    }

    .remove-package-btn {
        line-height: 8px;
        vertical-align: top;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Inventory/Replenishment/Shipment/CreateShipment/Step2.vue